import { render, staticRenderFns } from "./icons8.vue?vue&type=template&id=0dff3573&scoped=true&"
import script from "./icons8.vue?vue&type=script&lang=js&"
export * from "./icons8.vue?vue&type=script&lang=js&"
import style0 from "./icons8.vue?vue&type=style&index=0&id=0dff3573&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dff3573",
  null
  
)

export default component.exports